import { lazy } from "react";
import LazySuspenseComponent from "src/components/LazySuspenseComponent";

const DeepFakeCheck = lazy(() => import("../views/ContentCheck/DeepFake"));
const ImageClassCheck = lazy(() => import("../views/ContentCheck/ImageClass"));
const VideoClassCheck = lazy(() => import("../views/ContentCheck/VideoClass"));
const LLMCheck = lazy(() => import("../views/ContentCheck/LLMCheck"));
const ComprehensiveCheck = lazy(() =>
  import("../views/ContentCheck/ComprehensiveCheck")
);
const DiffusionCheck = lazy(() =>
  import("../views/ContentCheck/DiffusionCheck")
);
const DiffusionFullImage = lazy(() =>
  import("../views/ContentCheck/DiffusionFullImage")
);
const CheckResult = lazy(() => import("../views/CheckResult"));
const UserManagement = lazy(() => import("../views/UserManagement"));

const LoginPage = lazy(() => import("../views/LoginPage"));
const Ui = lazy(() => import("../views/Ui/Ui"));
const Report = lazy(() => import("../views/Report/Report"));
const Person = lazy(() => import("../views/Config/Person"));

export default [
  {
    path: "/", //占位，不可修改
    exact: true,
  },
  {
    path: "/content-check/image-class", // 图片检测大类
    exact: true,
    component: LazySuspenseComponent(ImageClassCheck, {
      menuUrl: "content-check-image-class",
    }),
    access: "image_class",
  },
  {
    path: "/content-check/video-class", // 视频检测大类
    exact: true,
    component: LazySuspenseComponent(VideoClassCheck, {
      menuUrl: "content-check-video-class",
    }),
    access: "video_class",
  },
  {
    path: "/content-check/deepfake",
    exact: true,
    component: LazySuspenseComponent(DeepFakeCheck, {
      menuUrl: "content-check-deepfake",
    }),
    access: "deepfake",
  },
  {
    path: "/content-check/diffusion",
    exact: true,
    component: LazySuspenseComponent(DiffusionCheck, {
      menuUrl: "content-check-diffusion",
    }),
    access: "diffusion",
  },
  {
    path: "/content-check/diffusion-full-frame",
    exact: true,
    component: LazySuspenseComponent(DiffusionFullImage, {
      menuUrl: "content-check-diffusion-full-frame",
    }),
    access: "diffusion_full_frame",
  },
  {
    path: "/content-check/llm",
    exact: true,
    component: LazySuspenseComponent(LLMCheck, {
      menuUrl: "content-check-llm",
    }),
    access: "llm",
  },
  // 综合检测
  {
    path: "/content-check/comprehensive-check",
    exact: true,
    component: LazySuspenseComponent(ComprehensiveCheck, {
      menuUrl: "content-check-comprehensive-check",
    }),
    access: "composite",
  },
  {
    path: "/user-management",
    exact: true,
    component: LazySuspenseComponent(UserManagement, {
      menuUrl: "user-management",
    }),
    access: "admin",
  },
  {
    path: "/check-result",
    exact: true,
    component: LazySuspenseComponent(CheckResult, { menuUrl: "check-result" }),
  },
  {
    path: "/config/person",
    exact: true,
    component: LazySuspenseComponent(Person, { menuUrl: "config-person" }),
    access: "admin",
  },
  {
    path: "/login",
    exact: true,
    component: LazySuspenseComponent(LoginPage),
  },
  {
    path: "/ui",
    a: 11111,
    component: LazySuspenseComponent(Ui, { menuUrl: "ui" }),
  },
  {
    path: "/report/:type/:id",
    exact: true,
    component: LazySuspenseComponent(Report, { menuUrl: "check-result" }),
  },
  {
    path: "/report/:type/:id",
    exact: true,
    component: LazySuspenseComponent(Report, { menuUrl: "check-result" }),
  },
];
